import React, { useState } from 'react';
import { ExternalLink, Calendar, MapPin, Globe, Utensils, Wrench, Zap, Snowflake, Building2, Laptop, Stethoscope, Smartphone } from 'lucide-react';

const VidarbhaGlobalFoundation = () => {
  const [hoveredFeatureId, setHoveredFeatureId] = useState(null);
  const [hoveredImageId, setHoveredImageId] = useState(null);
  const [hoveredNewsId, setHoveredNewsId] = useState(null);

  // Event details
  const eventInfo = {
    title: "Vidarbha Global Foundation",
    tagline: "Empowering Communities, Transforming Lives",
    date: "Nagpur Skill Center",
    location: "Vidarbha Region, Maharashtra",
    description: "The Vidarbha Global Foundation Skill Centre at Punapur—launched in collaboration with AID, Tata Strive, and NMC—is set to become one of India’s major skill development hubs. Built on a 30,000 sq. ft. campus, the centre will serve as a satellite facility until the upcoming Vidarbha Skill University is established at Sindhi Port. Designed to train 2,000 youth annually, the centre will offer industry-aligned, job-oriented programs across sectors such as hospitality, automotive, electrical and solar technologies, refrigeration and air-conditioning, banking, IT, digital skills, and healthcare. Advanced modules in smart manufacturing and Industry 4.0 technologies will be introduced as demand grows.Training will be free, with a refundable deposit, and 75% of seats reserved for Nagpur youth. The initiative reflects a strong commitment to creating a skilled workforce, expanding entrepreneurship opportunities, and strengthening Vidarbha’s regional skill ecosystem."
  };

  // Event highlights/features
  const highlights = [
    {
      id: 1,
      Icon: Utensils,
      title: "Hospitality",
      description: "Training programs in hotel management, culinary arts, and customer service for the hospitality industry.",
      image: "/img/aid.svg"
    },
    {
      id: 2,
      Icon: Wrench,
      title: "Automotive",
      description: "Comprehensive automotive training including vehicle maintenance, repair, and modern automotive technologies.",
      image: "/img/aid.svg"
    },
    {
      id: 3,
      Icon: Zap,
      title: "Electrician & Solar Technologies",
      description: "Skill development in electrical systems, renewable energy, and solar panel installation and maintenance.",
      image: "/img/aid.svg"
    },
    {
      id: 4,
      Icon: Snowflake,
      title: "Refrigeration & Air-Conditioning",
      description: "Technical training in HVAC systems, refrigeration technology, and climate control solutions.",
      image: "/img/aid.svg"
    },
    {
      id: 5,
      Icon: Building2,
      title: "Banking & Financial Services",
      description: "Financial literacy, banking operations, and digital payment systems training programs.",
      image: "/img/aid.svg"
    },
    {
      id: 6,
      Icon: Laptop,
      title: "Information Technology",
      description: "Computer literacy, software development, programming, and IT infrastructure training.",
      image: "/img/aid.svg"
    },
    {
      id: 7,
      Icon: Smartphone,
      title: "Digital Skills",
      description: "Digital marketing, social media management, e-commerce, and online business skills.",
      image: "/img/aid.svg"
    },
    {
      id: 8,
      Icon: Stethoscope,
      title: "Healthcare Support Roles",
      description: "Training in healthcare assistance, patient care, medical equipment handling, and health services.",
      image: "/img/aid.svg"
    }
  ];

  // Image gallery
  const eventImages = [
    {
      id: 1,
      url: "/img/vgf/1.jpeg",
      caption: "Community Engagement Program",
      alt: "Vidarbha Global Foundation Event"
    },
    {
      id: 2,
      url: "/img/vgf/2.jpeg",
      caption: "Skill Development Workshop",
      alt: "Training Session"
    },
    {
      id: 3,
      url: "/img/vgf/3.jpeg",
      caption: "Health & Wellness Camp",
      alt: "Healthcare Initiative"
    },
    {
      id: 4,
      url: "/img/vgf/4.jpeg",
      caption: "Education Program Launch",
      alt: "Educational Initiative"
    },
    {
      id: 5,
      url: "/img/vgf/5.jpeg",
      caption: "Women Empowerment Initiative",
      alt: "Women's Program"
    },
    {
      id: 6,
      url: "/img/vgf/6.jpeg",
      caption: "Rural Development Drive",
      alt: "Rural Outreach"
    }
  ];

  // News articles and media coverage
  const newsArticles = [
    {
      id: 1,
      title: "Nagpur Skill Centre Set to Make a Big Impact in Country",
      source: "The Times of India",
      date: "November 2025",
      excerpt: "The upcoming Vidarbha Global Foundation Skill Centre at Punapur - a joint initiative of AID, Tata Strive And NMC...",
      link: "https://timesofindia.indiatimes.com/city/nagpur/nagpur-skill-centre-set-to-make-a-big-impact-in-country/articleshow/125023364.cms?utm_source=chatgpt.com",
    },
    {
      id: 2,
      title: "Nitin Gadkari sets target of 5 lakh jobs in 5 yrs in Vidarbha",
      source: "The Economic Times",
      date: "November 2025",
      excerpt: "Five thousand youths from every assembly constituency in Vidarbha will get skill training at the Nagpur Skill Centre...",
      link: "https://economictimes.indiatimes.com/news/india/nitin-gadkari-sets-target-of-5-lakh-jobs-in-5-yrs-in-vidarbha-before-industry-body-says-its-achievable/articleshow/125016069.cms?from=mdr",
    },
    {
      id: 3,
      title: "Funds are not the problem, it's the lack of execution",
      source: "India TV",
      date: "November 2025",
      excerpt: "Gadkari appealed to local industries and entrepreneurs to concentrate on job creation in the Vidarbha region over the next five years....",
      link: "https://www.indiatvnews.com/maharashtra/funds-are-not-the-problem-its-the-lack-of-execution-says-nitin-gadkari-in-nagpur-event-watch-video-2025-11-01-1015410",
    },
    {
      id: 4,
      title: "Association for Industrial Development marks two years with New Office Launch in Nagpur",
      source: "The Live Nagpur",
      date: "November 2025",
      excerpt: "Bringing entrepreneurs together is vital – Pankaj Bhoyar Minister of State for Home & School Education Pankaj Bhoyar said....",
      link: "https://thelivenagpur.com/2025/11/25/association-for-industrial-development-marks-two-years-with-new-office-launch-in-nagpur/",
    },
    {
      id: 5,
      title: "Nitin Gadkari inaugurates Vidarbha Global Foundation Skill Centre in Nagpur",
      source: "The Hitavada",
      date: "November 2025",
      excerpt: "The Nagpur Skill Center will help realise the dreams of thousands of youth across the vidarbha....",
      link: "/img/vgf/hitvada.pdf",
    },
     {
      id: 6,
      title: "Nagpur Skill Center To Empower Vidarbha's Youth",
      source: "Lokmat Times",
      date: "November 2025",
      excerpt: "Calling it a historic initiative to boost youth employmentand industrial growth in vidarbha....",
      link: "/img/vgf/lokmat-times.pdf",
    }
  ];

  // Impact statistics
  const impactStats = [
    { number: "30,000", label: "Sq. Ft. Campus" },
    { number: "2,000", label: "Youth Trained Annually" },
    { number: "8+", label: "Industry Sectors" },
    { number: "75%", label: "Seats for Nagpur Youth" }
  ];

  return (
    <div style={{ fontFamily: '"Rubik", sans-serif', backgroundColor: "#fff", minHeight: "100vh", color: "#333", marginBottom: "60px" }}>
      <style>{`
        @media (max-width: 900px) {
          .vgf-hero-section {
            padding: 50px 20px !important;
          }
          .vgf-hero-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
          .vgf-hero-left {
            padding-right: 0 !important;
            text-align: center !important;
          }
          .vgf-hero-heading {
            font-size: 28px !important;
            text-align: center !important;
          }
          .vgf-hero-desc {
            font-size: 15px !important;
            text-align: center !important;
          }
          .vgf-hero-video-wrap {
            padding-left: 0 !important;
            transform: none !important;
          }
          .vgf-stats-bar {
            margin: 40px auto 0 !important;
            padding: 25px 20px !important;
            gap: 25px !important;
          }
          .vgf-section-pad {
            padding: 50px 20px !important;
          }
          .vgf-section-title {
            font-size: 28px !important;
          }
          .vgf-section-desc {
            font-size: 15px !important;
            margin-bottom: 30px !important;
          }
        }
      `}</style>

      {/* HERO SECTION */}
      <div className="vgf-hero-section" style={{
        position: "relative",
        overflow: "hidden",
        background: "linear-gradient(135deg, #fafbfc 0%, #f0f0f5 100%)",
        padding: "100px 20px"
      }}>
        {/* Main Container */}
        <div className="vgf-hero-grid" style={{
          maxWidth: "1300px",
          margin: "0 auto",
          position: "relative",
          display: "grid",
          gridTemplateColumns: "1.2fr 1fr",
          gap: "80px",
          alignItems: "center"
        }}>
          {/* Left Content */}
          <div className="vgf-hero-left" style={{
            position: "relative",
            zIndex: 2,
            textAlign: "left",
            paddingRight: "20px"
          }}>
            {/* Badge */}
            <div style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              padding: "10px 24px",
              background: "linear-gradient(135deg, #470172 0%, #764ba2 100%)",
              borderRadius: "50px",
              marginBottom: "30px",
              boxShadow: "0 4px 15px rgba(71, 1, 114, 0.2)"
            }}>
              <Globe size={18} color="#fff" />
              <span style={{ 
                fontSize: "14px", 
                fontWeight: "600", 
                color: "#fff",
                letterSpacing: "0.5px"
              }}>
                {eventInfo.date}
              </span>
            </div>

            {/* Main Heading */}
            <h1 className="vgf-hero-heading" style={{
              fontSize: "48px",
              fontWeight: "600", 
              lineHeight: "1.15", 
              color: "#3C007A",
              marginBottom: "30px",
              letterSpacing: "-1.5px",
              textAlign: "left"
            }}>
              <span style={{ 
                color: "#3C007A"
              }}>
                Vidarbha Global Foundation
              </span>
              <br />
              <span style={{ fontSize: "20px", color: "#4a5568", fontWeight: "500" }}>
                {eventInfo.tagline}
              </span>
            </h1>

            {/* Description */}
            <p className="vgf-hero-desc" style={{
              fontSize: "17px",
              color: "#4a5568",
              lineHeight: "1.8",
              marginBottom: "35px",
              textAlign: "left"
            }}>
              {eventInfo.description}
            </p>

            {/* Location Badge */}
            <div style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              background: "#fff",
              padding: "14px 28px",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              border: "2px solid rgba(71, 1, 114, 0.1)"
            }}>
              <MapPin size={20} color="#470172" />
              <span style={{ fontSize: "16px", color: "#470172", fontWeight: "600" }}>
                {eventInfo.location}
              </span>
            </div>
          </div>

          {/* Right Side - Video Showcase */}
          <div className="vgf-hero-video-wrap" style={{
            position: "relative",
            zIndex: 2,
            paddingLeft: "40px",
            transform: "scale(1.15)"
          }}>
            <div style={{
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 15px 50px rgba(71, 1, 114, 0.25)",
              border: "3px solid #fff",
              position: "relative",
              paddingBottom: "56.25%", // 16:9 aspect ratio
              height: 0
            }}>
              <iframe
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: "none"
                }}
                src="https://www.youtube.com/embed/Nb6Fuq3dAUM"
                title="Vidarbha Global Foundation Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>

        {/* Bottom Statistics Bar */}
        <div className="vgf-stats-bar" style={{
          maxWidth: "1100px",
          margin: "80px auto 0",
          padding: "35px 50px",
          background: "#fff",
          borderRadius: "16px",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "40px",
          boxShadow: "0 8px 30px rgba(71, 1, 114, 0.12)",
          border: "1px solid rgba(71, 1, 114, 0.1)"
        }}>
          {impactStats.map((stat, index) => (
            <div key={index} style={{ textAlign: "center", position: "relative" }}>
              {index !== 0 && (
                <div style={{
                  position: "absolute",
                  left: 0,
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: "1px",
                  height: "60%",
                  background: "linear-gradient(to bottom, transparent, rgba(71, 1, 114, 0.2), transparent)"
                }} />
              )}
              <div style={{ fontSize: "36px", fontWeight: "500", color: "#470172", marginBottom: "8px" }}>
                {stat.number}
              </div>
              <div style={{ fontSize: "15px", color: "#718096", fontWeight: "500", letterSpacing: "0.3px" }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* HEADER SECTION: OUR FOCUS AREAS */}
      <div className="vgf-section-pad" style={{ padding: "80px 20px", textAlign: "center", backgroundColor: "#fafbfc" }}>
        <h2 className="vgf-section-title" style={{ fontSize: "46px", fontWeight: "600", marginBottom: "24px", color: "#000000", letterSpacing: "-0.5px" }}>
          Our Focus Areas
        </h2>
        <p className="vgf-section-desc" style={{ maxWidth: "850px", margin: "0 auto 60px", color: "#666", lineHeight: "1.8", fontSize: "18px", fontWeight: "400" }}>
          Comprehensive programs designed to create sustainable impact across multiple sectors through community engagement, skill development, and innovative solutions.
        </p>

        {/* Feature Cards Grid */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "30px",
          maxWidth: "1300px",
          margin: "0 auto"
        }}>
          {highlights.map((highlight) => {
            const Icon = highlight.Icon;
            return (
              <div
                key={highlight.id}
                style={{
                  position: "relative",
                  background: "#fff",
                  borderRadius: "20px",
                  padding: "40px 30px",
                  boxShadow: "0 8px 30px rgba(0,0,0,0.06)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  border: "2px solid transparent",
                  overflow: "hidden"
                }}
              >
                {/* Icon Container */}
                <div style={{
                  width: "80px",
                  height: "80px",
                  marginBottom: "28px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  zIndex: 1,
                  background: "linear-gradient(135deg, rgba(71, 1, 114, 0.1) 0%, rgba(118, 75, 162, 0.15) 100%)",
                  borderRadius: "16px"
                }}>
                  <Icon 
                    size={40} 
                    color="#470172"
                  />
                </div>

                {/* Content */}
                <div style={{ position: "relative", zIndex: 1, textAlign: "center" }}>
                  <h3 style={{
                    fontSize: "22px",
                    fontWeight: "600",
                    marginBottom: "14px",
                    color: "#000000",
                    lineHeight: "1.3"
                  }}>
                    {highlight.title}
                  </h3>
                  <p style={{
                    fontSize: "16px",
                    color: "#777",
                    lineHeight: "1.7",
                    maxWidth: "260px",
                    margin: "0 auto",
                    fontWeight: "400"
                  }}>
                    {highlight.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Image Gallery Section */}
      <div className="vgf-section-pad" style={{ padding: "80px 20px", backgroundColor: "#fff" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 className="vgf-section-title" style={{ fontSize: "46px", fontWeight: "600", marginBottom: "24px", color: "#000000", letterSpacing: "-0.5px" }}>
              Event Gallery
            </h2>
            <p className="vgf-section-desc" style={{ maxWidth: "850px", margin: "0 auto", color: "#666", lineHeight: "1.8", fontSize: "18px", fontWeight: "400" }}>
              Capturing moments of transformation and community engagement across Vidarbha.
            </p>
          </div>

          {/* Images Grid */}
          <div style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))", 
            gap: "30px" 
          }}>
            {eventImages.map((image) => (
              <div
                key={image.id}
                style={{
                  position: "relative",
                  backgroundColor: "#fff",
                  borderRadius: "16px",
                  overflow: "hidden",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  border: "1px solid #eee"
                }}
              >
                <div style={{ height: "280px", position: "relative", overflow: "hidden" }}>
                  <img
                    src={image.url}
                    alt={image.alt}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover"
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* News & Media Coverage Section */}
      <div className="vgf-section-pad" style={{ padding: "80px 20px", backgroundColor: "#fafbfc" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 className="vgf-section-title" style={{ fontSize: "46px", fontWeight: "600", marginBottom: "24px", color: "#000000", letterSpacing: "-0.5px" }}>
              In The News
            </h2>
            <p className="vgf-section-desc" style={{ maxWidth: "850px", margin: "0 auto", color: "#666", lineHeight: "1.8", fontSize: "18px", fontWeight: "400" }}>
              Media coverage and news articles about our initiatives and impact across the region.
            </p>
          </div>

          {/* News Grid */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "30px" }}>
            {newsArticles.map((article) => (
              <div
                key={article.id}
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: hoveredNewsId === article.id ? "0 20px 40px rgba(0,0,0,0.12)" : "0 4px 10px rgba(0,0,0,0.05)",
                  display: "flex",
                  flexDirection: "column",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  border: "1px solid #eee",
                  transform: hoveredNewsId === article.id ? "translateY(-8px)" : "translateY(0)"
                }}
                onMouseEnter={() => setHoveredNewsId(article.id)}
                onMouseLeave={() => setHoveredNewsId(null)}
              >
                {/* Content Section */}
                <div style={{ padding: "24px", display: "flex", flexDirection: "column", flex: 1 }}>
                  <div style={{ 
                    fontSize: "13px", 
                    color: "#470172", 
                    fontWeight: "600", 
                    marginBottom: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}>
                    <span>{article.source}</span>
                    <span style={{ color: "#ccc" }}>•</span>
                    <span style={{ color: "#999" }}>{article.date}</span>
                  </div>

                  <h3 style={{
                    fontSize: "19px",
                    fontWeight: "600",
                    color: hoveredNewsId === article.id ? "#470172" : "#2d3748",
                    marginBottom: "12px",
                    lineHeight: "1.4",
                    transition: "color 0.3s ease",
                    flex: 1
                  }}>
                    {article.title}
                  </h3>

                  <p style={{
                    fontSize: "15px",
                    color: "#718096",
                    lineHeight: "1.6",
                    marginBottom: "20px"
                  }}>
                    {article.excerpt}
                  </p>

                  <a
                    href={article.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                      color: "#470172",
                      fontSize: "15px",
                      fontWeight: "600",
                      textDecoration: "none",
                      transition: "gap 0.3s ease"
                    }}
                    onClick={(e) => {
                      if (article.link.endsWith('.pdf')) {
                        e.preventDefault();
                        window.open(article.link, '_blank');
                      }
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.gap = "12px"}
                    onMouseLeave={(e) => e.currentTarget.style.gap = "8px"}
                  >
                    Read Full Article
                    <ExternalLink size={16} />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VidarbhaGlobalFoundation;
